import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-scroll-to-top",
  standalone: true,
  template: `
    <div
      id="angular-scroll-to-top"
      class="scroll-to-top"
      [class.visible]="isVisible"
      (click)="scrollToTop($event)"
    >
      <i class="fa fa-angle-up"></i>
    </div>
  `,
  styleUrls: ["./scroll-to-top.scss"],
})
export class ScrollToTopComponent implements OnInit, OnDestroy {
  isVisible = false; // Start hidden
  private scrollThreshold = 300; // Increased threshold for better UX
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    // console.log(
    //   "ScrollToTopComponent constructor - isBrowser:",
    //   this.isBrowser
    // );
  }

  ngOnInit() {
    // console.log("ScrollToTopComponent ngOnInit");
    if (this.isBrowser) {
      // Initial check
      setTimeout(() => {
        this.checkScrollPosition();
        // console.log("Initial scroll check completed");
      }, 100);
    }
  }

  ngOnDestroy() {
    // console.log("ScrollToTopComponent ngOnDestroy");
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (!this.isBrowser) return;
    this.checkScrollPosition();
  }

  @HostListener("window:resize", [])
  onWindowResize() {
    if (!this.isBrowser) return;
    this.checkScrollPosition();
  }

  private checkScrollPosition() {
    if (!this.isBrowser) return;

    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    const shouldBeVisible = scrollTop > this.scrollThreshold;

    // Only update if the state actually changes
    if (this.isVisible !== shouldBeVisible) {
      this.isVisible = shouldBeVisible;
      // console.log(
      //   "Scroll position changed - isVisible:",
      //   this.isVisible,
      //   "scrollTop:",
      //   scrollTop
      // );
    }
  }

  scrollToTop(event: Event) {
    event.preventDefault();
    // console.log("Scroll to top clicked");

    if (!this.isBrowser) return;

    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}
